import moment from "moment";
import { Trans, useTranslation } from "react-i18next";
import Link from "src/components/Link";
import ConnectDiscountBanner from "src/components/promotion/banners/ConnectDiscountBanner";
import Button from "src/components/Button";
import Layout from "src/components/layout/Layout";
import SubscriptionCheckoutHead from "src/components/subscription/SubscriptionCheckoutHead";
import SubscriptionPlans from "src/components/subscription/SubscriptionPlans";
import useAuth from "src/hooks/selectors/useAuth";
import useSubscription from "src/hooks/selectors/useSubscription";

export default function SubscriptionView() {
	const { t } = useTranslation("subscription-view", {
		keyPrefix: "index-view",
	});
	const auth = useAuth();
	const promos = auth?.company?.promos || [];
	const subscription = useSubscription();
	const days = moment().diff(moment(auth?.company?.created_at), "days");

	if (subscription && !subscription?.is_paused) {
		return (
			<Layout hideNav>
				<div className="flex flex-col justify-center items-center flex-1">
					<h2 className="mb-8">{t("already.title")}</h2>
					<Button to="/dashboard">
						{t("already.button")}
						<i className="fas fa-arrow-right ml-4"></i>
					</Button>
				</div>
			</Layout>
		);
	}

	return (
		<Layout hideNav>
			<div className="flex flex-col flex-1">
				<div className="mb-4 md:mb-0 block">
					<Link className="underline" to="/dashboard">
						{t("back")}
					</Link>
				</div>

				{promos?.includes("connect_discount") && (
					<div className="flex flex-col justify-center items-center">
						<ConnectDiscountBanner type="countdown" />
					</div>
				)}

				{promos.includes("loyal") ? (
					<SubscriptionCheckoutHead
						title={t("loyal.title")}
						subtitle={
							<>
								<Trans i18nKey="loyal.description" {...{ t }}>
									Bedankt dat je al
									<strong>{{ days }}</strong> dagen een klant
									van ons bent! Daarom hebben we voor jou een
									speciale korting.
								</Trans>
							</>
						}
					/>
				) : (
					<SubscriptionCheckoutHead
						title={t("head.title")}
						subtitle={t("head.subtitle")}
					/>
				)}
				<SubscriptionPlans />
			</div>
		</Layout>
	);
}
